import { OutputToConsoleFunc } from "../../@types"
import { SessionResult, SessionStartupFuncs, start, startLater } from "./start"
import { loadWhenReady } from "./whenDocumentReady"

/**
 * Called by tag owner code to initialize a RUM session, either immediately or
 * after some delay.
 *
 * @remarks
 * Waits for the page to load before processing.
 *
 * @param getDocumentReadyState Function to get the current document ready state
 * @param addDocumentReadyStateChangeListener Function to add a listener for ready state changes
 * @param sessionConfigDelayInMilliseconds Delay before starting the session
 * @param sessionStartupFuncs Array of session startup function objects
 * @param outputToConsole Logging function for diagnostics
 */
export function init(
  getDocumentReadyState: () => DocumentReadyState,
  addDocumentReadyStateChangeListener: (callback: () => void) => void,
  sessionConfigDelayInMilliseconds: number,
  sessionStartupFuncs: SessionStartupFuncs[],
  outputToConsole: OutputToConsoleFunc,
): Promise<SessionResult> {
  return loadWhenReady(
    getDocumentReadyState,
    addDocumentReadyStateChangeListener,
  ).then(() => {
    if (sessionConfigDelayInMilliseconds > 0) {
      return startLater(
        sessionConfigDelayInMilliseconds,
        sessionStartupFuncs,
        outputToConsole,
      )
    }
    return start(sessionStartupFuncs, outputToConsole)
  })
}
